import { render, staticRenderFns } from "./ActivityLogItem.vue?vue&type=template&id=15130fd1&scoped=true&"
import script from "./ActivityLogItem.vue?vue&type=script&lang=ts&"
export * from "./ActivityLogItem.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityLogItem.vue?vue&type=style&index=0&id=15130fd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15130fd1",
  null
  
)

export default component.exports